import checkout from "./form";

const {
  formField: { name, description },
} = checkout;

const initialValues = {
  [name.name]: "",
  [description.name]: "",
};

export default initialValues;
